var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.props.value.funding_record)?_c(_setup.FundingStatusBadge,{attrs:{"record":_setup.props.value.funding_record}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }